export const DEPLOY_MARKER = process.env.VUE_APP_DEPLOY_MARKER